import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'
import Tools from '@/components/tools/Tools.js'

import AccountRepository from '@/shared/http/repositories/access/account'
import AccountModel from '@/shared/models/access/accountmodel'
import AccountForms from './profile-form'
import AccountMixin from '@/store/module/account/mixin'

export default {
  name: 'profile',
  mixins: [
    ActionsForm,
    AccountMixin
  ],
  data () {
    return {
      data: AccountModel,
      form: AccountForms
    }
  },
  mounted () {
    this.getLogged()
  },
  methods: {
    onLoad () {
      Tools.SetValueInForm(this.form, this.data, this.account)
    },
    onUpdate () {
      loading.push()
      AccountRepository.Update(this.data)
        .then((response) => {
          setTimeout(() => {
            this.$router.push({ name: 'StartPage' })
          }, 1000)
          loading.pop()
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onCheckEmail () {
      var email = this.form.email.value
      loading.push()
      AccountRepository.GetByEmail(email)
        .then((response) => {
          if (response) {
            if (response.data.data) {
              var obj = response.data.data
              if (obj) {
                toast.warning(this.$lang.Accounts.AlertEmailExisted)
              }
            }
          }
          loading.pop()
        })
        .catch((err) => {
          this.onException(err)
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/myaccount/profile/profile.js